import React from 'react';
import './LoginPage.css';
import { Link } from 'react-router-dom';
import routes from '../utils/routes';
import LoginTab from '../components/forms/LoginTab';
import bannerImage from '../assets/images/logo.svg';


function LoginPage() {
  return (
    <div className="login-container">
      <div className="form-modal">
        <Link to={routes.home} className="backhome-icon">
          <span className="material-symbols-outlined">arrow_back</span>
        </Link>
        <div className="form-image">
          <img src={bannerImage} alt="modal-image" />
        </div>
        <LoginTab />
      </div>
    </div>
  );
}

export default LoginPage;
